define('models/HybridRoutingModel',['underscore','ObjectModel'],function (_,ObjectModel) {
    //
    // Model HybridRouting
    //
    var HybridRoutingModelPrototype = {
        
        name:'HybridRoutingModel',
        idAttribute:'id_front_controller',
        defaults:{
            rollingstart: false,
            excludes: [],
        },
        
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },
        isRoute:function(url,page,options){
            var model = this,
                classname = model.get('classname'),
                controllerName = page+"Controller";
            switch(page){
                case "Listing":
                    controllerName = "CategoryController";
            }
            if(controllerName===classname){
                return true;
            }
            return false;
        },
        usePageReload:function(url,page,options){
            var model = this,
                rollingstart = model.get('rollingstart'),
                usePageReload = rollingstart,
                excludes = model.get('excludes'),
                classname = model.get('classname');
            if(classname === 'WidgetController'){
                usePageReload = rollingstart && !_(excludes).contains('/'+url);
            }
            return usePageReload;
        }
    };

    var HybridRoutingModel = ObjectModel.extend(HybridRoutingModelPrototype);
    
    return HybridRoutingModel;
});
